import React from "react";

export const pathDictionary = {
  cardiorespiratory: "medicine/cardiorespiratory",
  gastro: "medicine/gastrointestinal",
  neuro: "medicine/neurology",
  haem: "medicine/haematology",
  id: "medicine/id-disease",
  renal: "medicine/renal",
  rheum: "medicine/rheum",
  endo: "medicine/endocrinology",
  derm: "specialties/dermatology",
  ent: "specialties/ent",
  gp: "specialties/gp",
  gynae: "specialties/gynaecology",
  obstetrics: "specialties/obstetrics",
  ophthal: "specialties/ophthalmology",
  paeds: "specialties/paediatrics",
  psych: "specialties/psychiatry",
  breast: "surgery/breast",
  generalsurg: "surgery/general",
  traumaortho: "surgery/ortho",
  urology: "surgery/urology",
  vascular: "surgery/vascular",
  miscellaneous: "miscellaneous",
  ethics_law: "ethics-and-law",
};

export const stationTypeDictionary = {
  history: "History ✍🏼",
  examination: "Examination 🩺",
  emergency: "Emergency 🚑",
  explanation: "Explanation 🗣",
  data_interpretation: "Data Interpretation 📈",
  mixed: "Mixed ♾",
  communication: "Communication 📣",
  ethics_law: "Ethics and Law ⚖️",
  procedures: "Procedures 💉",
};

export const markschemeTypeDictionary = {
  "all-markschemes.introduction": "Introduction",
  "history-markschemes.presenting-complaint": "Presenting complaint",
  "history-markschemes.history-presenting-complaint":
    "History of presenting complaint",
  "history-markschemes.past-medical-history": "Past medical history",
  "history-markschemes.drug-history": "Drug history",
  "history-markschemes.obstetric-history": "Obs and Gynae history",
  "history-markschemes.sexual-history": "Sexual history",
  "history-markschemes.family-history": "Family history",
  "history-markschemes.social-history": "Social history",
  "history-markschemes.systems-review": "Systems review",
  "history-markschemes.ideas-concerns-expectations":
    "Ideas, concerns and expectations",
  "all-markschemes.conclusion": "Conclusion",
  "all-markschemes.diagnosis": "Diagnosis",
  "all-markschemes.investigations": "Investigations",
  "all-markschemes.management": "Management",
  "all-markschemes.questions": "Questions",
  "abcde-markscheme.call_for_help": "Call for help",
  "abcde-markscheme.basic_observations": "Basic Observations",
  "abcde-markscheme.disability": "Disability",
  "abcde-markscheme.breathing": "Breathing",
  "abcde-markscheme.response": "Response",
  "abcde-markscheme.circulation": "Circulation",
  "abcde-markscheme.danger": "Danger",
  "abcde-markscheme.airway": "Airway",
  "abcde-markscheme.exposure": "Exposure",
  "neurological-examination-markschemes.reflexes": "Reflexes",
  "neurological-examination-markschemes.coordination": "Coordination",
  "neurological-examination-markschemes.special-tests": "Special-tests",
  "neurological-examination-markschemes.cn-xi": "CN 11",
  "neurological-examination-markschemes.cn-viii": "CN 8",
  "neurological-examination-markschemes.cn-i": "CN 1",
  "neurological-examination-markschemes.cn-iii-iv-vi": "CN 3,4,6",
  "neurological-examination-markschemes.sensation": "Sensation",
  "neurological-examination-markschemes.cn-ii": "CN 2",
  "neurological-examination-markschemes.tone": "Tone",
  "neurological-examination-markschemes.cn-v": "CN 5",
  "neurological-examination-markschemes.cn-vii": "CN 7",
  "neurological-examination-markschemes.power": "Power",
  "neurological-examination-markschemes.cn-ix-x-xii": "CN 9,10,12",
  "examination-general-markschemes.inspection": "Inspection",
  "examination-general-markschemes.percussion": "Percussion",
  "examination-general-markschemes.auscultation": "Auscultation",
  "examination-general-markschemes.face": "Face",
  "examination-general-markschemes.look": "Look",
  "examination-general-markschemes.neck": "Neck",
  "examination-general-markschemes.palpation": "Palpation",
  "examination-general-markschemes.feel": "Feel",
  "examination-general-markschemes.hands": "Hands",
  "examination-general-markschemes.move": "Move",
  "examination-general-markschemes.presentation": "Presentation",
  "examination-general-markschemes.findings": "Findings",
  "neurological-examination-markschemes.gait": "Gait",
  "examination-general-markschemes.function": "Function",
  "examination-general-markschemes.ankles": "Ankles",
  "examination-general-markschemes.chest": "Chest",
  "examination-general-markschemes.legs": "Legs",
  "examination-general-markschemes.back": "Back",
  "examination-general-markschemes.speculum": "Speculum",
  "examination-general-markschemes.groin": "Groin",
  "examination-general-markschemes.abdomen": "Abdomen",
  "explanation-markscheme.when": "When",
  "explanation-markscheme.why": "Why",
  "explanation-markscheme.benefits": "Benefits",
  "explanation-markscheme.before": "Before",
  "explanation-markscheme.how": "How",
  "explanation-markscheme.other": "Other",
  "explanation-markscheme.during": "During",
  "explanation-markscheme.what": "What",
  "explanation-markscheme.contraindications": "Contraindications",
  "explanation-markscheme.after": "After",
  "explanation-markscheme.prognosis": "Prognosis",
  "explanation-markscheme.risks": "Risks",
  "explanation-markscheme.description": "Description",
};
